// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-29782c78]{display:none}button[data-v-29782c78]{all:unset}.text-button[data-v-29782c78]{color:var(--c-primary-500);cursor:pointer;font-weight:var(--font-weight--bold);padding:var(--spacer-sm) 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
